/**
 * Blog PDF Download
 * Fills CF7 context and shows a custom success message.
 * The landing page is public, so no access cookie is set.
 */

function setHiddenValue(wrapper, name, value) {
    if (!value) return;
    const field = wrapper.querySelector('input[name="' + name + '"]');
    if (field && !field.value) {
        field.value = value;
    }
}

function fillFormContext(wrapper) {
    setHiddenValue(wrapper, 'blog-post-id', wrapper.dataset.blogPostId);
    setHiddenValue(wrapper, 'blog-title', wrapper.dataset.blogTitle);
    setHiddenValue(wrapper, 'blog-url', wrapper.dataset.blogUrl);
    setHiddenValue(wrapper, 'pdf-name', wrapper.dataset.pdfName);
}

function showSuccessMessage(wrapper) {
    const formWrap = wrapper.querySelector('.pdf-download-form');
    const success = wrapper.querySelector('.pdf-download-success');
    const note = wrapper.querySelector('.pdf-download-form-note');

    if (formWrap) {
        formWrap.classList.add('hidden');
    }

    if (note) {
        note.classList.add('hidden');
    }

    if (success) {
        success.classList.remove('hidden');
    }
}

export function initBlogPdfDownload() {
    const wrappers = document.querySelectorAll('.blog-pdf-download');
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
        fillFormContext(wrapper);
    });

    document.addEventListener('wpcf7mailsent', function (event) {
        const target = event.target;
        if (!target || typeof target.closest !== 'function') return;

        const wrapper = target.closest('.blog-pdf-download');
        if (!wrapper || !wrapper.querySelector('.wpcf7')) return;

        showSuccessMessage(wrapper);
    }, false);
}
